import { lazy } from 'react'

export const Menu = lazy(() => import('./Menu'))
